module.exports = __webpack_public_path__ + "dingbeauty-build/img/plan-default-Image@2x.4f3f6175.png";